import Npvr from './npvr';

export { Npvr };

export default Npvr;
